import React, { useState, useEffect } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AssociateNavBar from "components/Navbars/AssociateNavBar";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import managerRoutes from "managerRoutes.js";

const ManagerLayout = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  const [logo, setLogo] = useState(
    require("../assets/img/brand//adect-logo.png").default
  );

  useEffect(() => {
    const idenfityLogo = () => {
      if (process.env.REACT_APP_TENANT.includes("ADECT")) {
        setLogo(require("../assets/img/brand//adect-logo.png").default);
      } else if (process.env.REACT_APP_TENANT.includes("GCO")) {
        setLogo(require("../assets/img/brand//gco-logo.png").default);
      } else if (process.env.REACT_APP_TENANT.includes("APPSTORE")) {
        setLogo(require("../assets/img/brand//asqs-logo.png").default);
      }
    };
    idenfityLogo();
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (managerRoutes) => {
    return managerRoutes.map((prop, key) => {
      if (prop.layout === "/manager") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < managerRoutes.length; i++) {
      if (
        props.location.pathname.indexOf(
          managerRoutes[i].layout + managerRoutes[i].path
        ) !== -1
      ) {
        return managerRoutes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        managerRoutes={managerRoutes}
        logo={{
          innerLink: "/manager/home",
          imgSrc: logo,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AssociateNavBar
          {...props}
          data={[1, 2, 3]}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(managerRoutes)}
          <Redirect from="*" to="/manager/home" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default ManagerLayout;
